<template>
  <div class="page">
    <div class="banner">

    </div>
    <div class="login">
      <h3>用戶登錄</h3>
      <input v-model="phone" type="tel" maxlength="10" placeholder="請輸入手機號">
      <div class="code">
        <input v-model="code" type="tel" maxlength="6" placeholder="請輸入驗證碼">
        <p @click="getCode">{{ getVCodeTxt }}</p>
      </div>
      <button @click="login">登錄</button>
    </div>
  </div>
</template>

<script>
import { encryptAES, decryptAES } from '../encrypt';
import axios from 'axios';
export default {
  name: 'Login',
  data() {
    return {
      phone: '',
      code: '',
      getVCodeTxt: '發送簡訊',
      isCountDown: false,
    }
  },
  created() {
    this.$store.dispatch('updateIndex', -1); // 提交变更
  },
  methods: {
    async getCode() {
      const { phone,isCountDown } = this
      
      
      if (isCountDown) {
        this.$message({
          message: '請稍後再發送',
          type: 'warning'
        });
        return
      }
      if (!phone) {
        this.$message({
          message: '請輸入手機號',
          type: 'error'
        });
        return
      }


      const loading = this.$loading({
        lock: true,               // 是否锁定屏幕
        text: '正在發送...',        // 显示文本
        spinner: 'el-icon-loading', // 加载图标
        background: 'rgba(0, 0, 0, 0.7)', // 背景色
      });
      const data = {
        mobile: phone,
        type: 'text'


      };
      let defaultToken = {
        "countryCode": "886",
        "sourceChannel": "Organic",
        "packageName": "com.aizhigu.com",
        "adid": "000000000000",
        "version": "5.0.0",
        "uuId": "",
        "userId": ""
      }
      let defaultAESToken = encryptAES(JSON.stringify(defaultToken), 'IGTXAD1bZopZeEP5y8lvX4cIAO5vSZkj', true)
      const AESdata = encryptAES(JSON.stringify(data))
      console.log(decryptAES(AESdata))

      try {
        // 发送POST请求
        const response = await axios.post(
          'https://mmxdgame.com/auth/v1/user/sendOtp',
          AESdata, // 请求体数据
          {
            headers: {
              'content-type': 'text/plain; charset=utf-8',
              'version': '5.0.0',
              'sourceChannel': 'Organic',
              'packageName': 'com.aizhigu.com',
              // "itwsp": "aizg",
              'countryCode': '886',
              'SQXI': defaultAESToken,
              'userId': '',
              'uuId': ''
            }
          }
        );
        let res = null
        if (typeof response.data == 'object') {
          // 明文返回
          res = response.data
        } else {
          //解密数据
          res = JSON.parse(decryptAES(response.data))
        }
        if (res.status == 200) {
          loading.close();

          this.$message.success('已發送');
          this.countDown();

        } else {
          loading.close();
          this.$message.error(res.message);

        }
      } catch (error) {
        loading.close();
        this.$message.error(error.message);
        console.error('提交失败', error);
      }

    },
    countDown() {
      this.isCountDown = true
      let seconds = 180;
      // 重新获取
      this.getVCodeTxt = `重新發送(${seconds}s)`
      this.timer = setInterval(() => {
        seconds--;
        this.getVCodeTxt = `重新發送(${seconds}s)`
        if (seconds == 0) {
          clearInterval(this.timer);
          this.getVCodeTxt = '重新發送'
          this.isCountDown = false
        }
      }, 1000)
    },
    async login() {
      const { phone, code } = this
      if (!phone) {
        this.$message({
          message: '請輸入手機號',
          type: 'error'
        });
        return
      }
      if (!code) {
        this.$message({
          message: '請輸入驗證碼',
          type: 'error'
        });
        return
      }

      const loading = this.$loading({
        lock: true,               // 是否锁定屏幕
        text: '正在登錄...',        // 显示文本
        spinner: 'el-icon-loading', // 加载图标
        background: 'rgba(0, 0, 0, 0.7)', // 背景色
      });
      const data = {
        phone,
        code,
        type: 'text'


      };
      let defaultToken = {
        "countryCode": "886",
        "sourceChannel": "Organic",
        "packageName": "com.aizhigu.com",
        "adid": "000000000000",
        // "itwsp": "aizg",
        "version": "5.0.0",
        "uuId": "",
        "userId": ""
      }
      let defaultAESToken = encryptAES(JSON.stringify(defaultToken), 'IGTXAD1bZopZeEP5y8lvX4cIAO5vSZkj', true)
      const AESdata = encryptAES(JSON.stringify(data))
      console.log(decryptAES(AESdata))

      try {
        // 发送POST请求
        const response = await axios.post(
          'https://mmxdgame.com/auth/v1/user/login',
          AESdata, // 请求体数据
          {
            headers: {
              'content-type': 'text/plain; charset=utf-8',
              'version': '5.0.0',
              'sourceChannel': 'Organic',
              'packageName': 'com.aizhigu.com',
              // "itwsp": "aizg",
              'countryCode': '886',
              'SQXI': defaultAESToken,
              'userId': '',
              'uuId': ''
            }
          }
        );
        let res = null
        if (typeof response.data == 'object') {
          // 明文返回
          res = response.data
        } else {
          //解密数据
          res = JSON.parse(decryptAES(response.data))
        }

        console.log(res)
        if (res.status == 200) {
          loading.close();
          this.$message.success('登錄成功');
          localStorage.setItem('loginInfo', JSON.stringify(res.body));
          let tokenData = {
            "countryCode": "886",
            "sourceChannel": "Organic",
            "packageName": "com.aizhigu.com",
            "adid": "000000000000",
            // "itwsp": "aizg",
            "version": "5.0.0",
            "uuId": res.body.uuId,
            "userId": res.body.userId
          }
          let AEStoken = encryptAES(JSON.stringify(tokenData), 'IGTXAD1bZopZeEP5y8lvX4cIAO5vSZkj', true)
          localStorage.setItem('token', AEStoken)
          this.$router.push('/recharge');
          location.reload()

        } else {
          loading.close();
          this.$message.error(response.data.message);

        }
      } catch (error) {
        loading.close();
        this.$message.error(error.message);
        console.error('提交失败', error);
      }

    },

  }
};
</script>

<style lang="scss" scoped>
/* 样式 */
.page {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;

  .banner {
    width: 100%;
    height: 300px;
    position: relative;
    
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding-top: 140px;

    &::before {
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.25);
      z-index: 1;
    }

    h2 {
      font-size: 40px;
      font-weight: lighter;
      color: #fff;
      line-height: 1.5;
      position: relative;
      z-index: 10;
    }

    p {
      margin-top: 20px;
      font-size: 16px;
      color: #fff;
      font-weight: bold;
      position: relative;
      z-index: 10;

      span {
        display: inline-block;
        width: 5px;
        height: 5px;
        margin: 0 10px;
        border-radius: 50%;
        background-color: #fff;
      }

      a {
        font-style: normal;
        color: #fff;
        text-decoration: unset;

        &:hover {
          color: rgb(242, 172, 36);
        }
      }
    }
  }

  .login {
    width: 460px;
    box-sizing: border-box;
    padding: 30px;
    border-radius: 10px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;

    h3 {
      font-size: 32px;
      color: #333;
      margin-bottom: 50px;
    }

    input {
      height: 56px;
      width: 100%;
      border-radius: 5px;
      background-color: #f8fafc;
      box-sizing: border-box;
      padding: 0 20px;
      font-size: 18px;
      color: #333;
      border: 1px solid #f8fafc;
      margin-bottom: 20px;
    }

    .code {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      input {
        width: 70%;
      }

      p {
        cursor: pointer;
        color: #4d6ee4;
        font-size: 16px;
        text-decoration: underline;

        &:hover {
          color: #3b5bdc;
        }
      }
    }

    button {
      border: none;
      background-color: #4d6ee4;
      width: 100%;
      height: 56px;
      border-radius: 5px;
      font-size: 18px;
      color: #fff;
      font-weight: bold;
    }
  }
}
@media screen and (max-width: 960px) {
  .page {


  .banner {
    width: 100%;
    height: 40vmin;
    
    // padding-top: 20vmin;

    &::before {
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.25);
      z-index: 1;
    }

    h2 {
      font-size: 40px;
      font-weight: lighter;
      color: #fff;
      line-height: 1.5;
      position: relative;
      z-index: 10;
    }

    p {
      margin-top: 20px;
      font-size: 16px;
      color: #fff;
      font-weight: bold;
      position: relative;
      z-index: 10;

      span {
        display: inline-block;
        width: 5px;
        height: 5px;
        margin: 0 10px;
        border-radius: 50%;
        background-color: #fff;
      }

      a {
        font-style: normal;
        color: #fff;
        text-decoration: unset;

        &:hover {
          color: rgb(242, 172, 36);
        }
      }
    }
  }

  .login {
    width: 100%;
    box-sizing: border-box;
    padding: 4vmin;
    border-radius: 2vmin;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;

    h3 {
      font-size: 32px;
      color: #333;
      margin-bottom: 50px;
    }

    input {
      height: 56px;
      width: 100%;
      border-radius: 5px;
      background-color: #f8fafc;
      box-sizing: border-box;
      padding: 0 20px;
      font-size: 18px;
      color: #333;
      border: 1px solid #f8fafc;
      margin-bottom: 20px;
    }

    .code {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      input {
        width: 70%;
      }

      p {
        cursor: pointer;
        color: #4d6ee4;
        font-size: 16px;
        text-decoration: underline;

        &:hover {
          color: #3b5bdc;
        }
      }
    }

    button {
      border: none;
      background-color: #4d6ee4;
      width: 100%;
      height: 56px;
      border-radius: 5px;
      font-size: 18px;
      color: #fff;
      font-weight: bold;
    }
  }
}
}
</style>